module.exports = __webpack_public_path__ + "static/fabrica-slide1-76dd155a8b90b5a9a27a6a8966e4182b.jpg";